/**
 * @desc: 下拉选择器请求接口，公用部分
 * @created: 2020/4/15
 * @author:yeungyifan
 * @version : v1.0
 */
import request from '@/plugins/http'

// 行业类型 - 供应商
export const getMcc = params => {
  return request.get('/supplier/getMcc', params)
}

// 行业类型 - 商户
export const getBaseMcc = params => {
  return request.get('/merchant/entry/getBaseMcc', params)
}

// 品类信息
export const getCategory = params => {
  return request.get('/supplier/getCategory', params)
}

// 调用方
export const getQueryCallerVo = params => {
  return request.get('/apiManager/apiList/queryCallerVo', params)
}

// 可选通道
export const getPaychannels = params => {
  return request.get('/merchant/card/paychannels', params)
}
